export const SmoothScroll = (offset = 0) => {
  const scrollToTarget = (element) => {
    const rect = element.getBoundingClientRect();
    const absoluteTop = window.pageYOffset + rect.top;
    const targetPosition = absoluteTop + offset;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth',
    });
  };

  const hashScroll = () => {
    const hash = location.hash.replace('#', '');
    if (!hash) return;

    const target = document.getElementById(hash);
    if (target) {
      scrollTo(0, 0); // Safari対策
      setTimeout(() => {
        scrollToTarget(target);
      }, 0);
    }
  };

  const links = document.querySelectorAll('a[href*="#"]');
  links.forEach(link => {
    const href = link.getAttribute('href');
    const url = new URL(href, location.origin);

    const hash = url.hash.replace('#', '');
    if (!hash) return;

    link.addEventListener('click', function (e) {
      if (url.pathname === location.pathname) {
        // 同一ページ内
        const target = document.getElementById(hash);
        if (target) {
          e.preventDefault();
          history.pushState(null, null, `#${hash}`);
          scrollToTarget(target);
        }
      } else {
        // 別ページ → ハッシュ付きで遷移（スクロールは遷移先で）
        // ここでは防がず、通常のナビゲーションでOK
        // スムーズスクロールは遷移先で hashScroll() が呼ばれる
      }
    });
  });

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  window.addEventListener('load', () => {
    hashScroll();
    console.log(`SmoothScroll loaded!`);
  });
};
